import { useLingui } from "@lingui/react/macro";
import { List, Text, Title } from "@mantine/core";
import { createFileRoute } from "@tanstack/react-router";

import { DocHeading } from "@/components/docs/DocHeading.tsx";
import { DocsContent } from "@/components/docs/DocsContent.tsx";

export const Route = createFileRoute("/docs/getting-started/login")({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useLingui();

  return (
    <DocsContent>
      <Title order={1} size="h2">{t`Logging in`}</Title>
      <Text>
        {t`REALity supports login through Sweco’s identity system and single sign-on. You use your ordinary Sweco account and do not need a separate REALity password.`}
      </Text>

      <DocHeading order={2} size="h3">{t`How to sign in`}</DocHeading>
      <List type="ordered" withPadding>
        <List.Item>{t`TODO: add steps.`}</List.Item>
      </List>
    </DocsContent>
  );
}
